(function () {
  var PRODUCT_SECTION_CLASS = 'shopify-section--main-product';
  var GALLERY_SELECTOR = '.product-gallery';
  var IS_PDP = !!document.querySelector('.' + PRODUCT_SECTION_CLASS);
  var productCache = Object.create(null);
  var sectionCache = Object.create(null);
  var sectionInFlight = Object.create(null);

  function fetchProduct(handle, signal) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin', signal: signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) productCache[handle] = j; return j; });
  }

  function preloadImage(url, srcset, sizes) {
    if (!url) return Promise.resolve();
    var img = new Image();
    img.decoding = 'async';
    // sizes + srcset BEFORE src, so the warm resolves to the same candidate the
    // gallery renders (1200 on a phone, 1600 on desktop) instead of the 1600 fallback.
    if (srcset) { if (sizes) img.sizes = sizes; img.srcset = srcset; }
    img.src = url;
    if (img.decode) return img.decode().catch(function () {});
    return new Promise(function (resolve) { img.onload = img.onerror = resolve; });
  }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  if (IS_PDP) {
    var pdp = {};

    pdp.mainSection = function () {
      return document.querySelector('.' + PRODUCT_SECTION_CLASS);
    };

    pdp.mainSectionId = function () {
      var el = pdp.mainSection();
      return el ? el.id.replace(/^shopify-section-/, '') : null;
    };

    pdp.wrappingSectionId = function (el) {
      var s = el && el.closest('.shopify-section');
      return s ? s.id.replace(/^shopify-section-/, '') : null;
    };

    pdp.buildSectionsUrl = function (url, ids) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('sections', ids.join(','));
      return u.toString();
    };

    pdp.toggleLoading = function (on) {
      var targets = [];
      var main = pdp.mainSection();
      if (main) targets.push(main);
      document.querySelectorAll('[data-product-refresh-full]').forEach(function (n) {
        var s = n.closest('.shopify-section');
        if (s) targets.push(s);
      });
      document.querySelectorAll('[data-product-refresh-images]').forEach(function (n) {
        var s = n.closest('.shopify-section');
        if (s) targets.push(s);
      });
      targets.forEach(function (sec) {
        sec.classList.toggle('is-loading', !!on);
        sec.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    };

    pdp.variantPicker = function () {
      var sec = pdp.mainSection();
      return sec && sec.querySelector('variant-picker');
    };

    pdp.currentHandle = function () {
      var vp = pdp.variantPicker();
      if (vp && vp.getAttribute('handle')) return vp.getAttribute('handle');
      var m = location.pathname.match(/\/products\/([^\/\?]+)/);
      return m ? m[1] : null;
    };

    pdp.selectedSize = function () {
      var sec = pdp.mainSection();
      if (!sec) return null;
      var sets = sec.querySelectorAll('fieldset.variant-picker__option, .variant-picker__option');
      for (var i = 0; i < sets.length; i++) {
        var fs = sets[i];
        var legend = fs.querySelector('legend, .variant-picker__option-info legend');
        var label = (legend && legend.textContent || '').trim().toLowerCase();
        if (label === 'size') {
          var checked = fs.querySelector('input[type="radio"]:checked');
          if (checked && checked.value) return checked.value;
        }
      }
      var any = sec.querySelector('input[type="radio"][name^="option"]:checked');
      return any ? any.value : null;
    };

    pdp.selectedOptions = function () {
      var sec = pdp.mainSection();
      if (!sec) return [];
      var out = [];
      var i = 1, input;
      while ((input = sec.querySelector('input[type="radio"][name="option' + i + '"]:checked'))) {
        out.push(input.value);
        i++;
      }
      return out;
    };

    pdp.currentProductJson = function () {
      var h = pdp.currentHandle();
      return h ? productCache[h] || null : null;
    };

    pdp.sizeOptionIndex = function (json) {
      if (!json || !Array.isArray(json.options)) return 0;
      var idx = json.options.findIndex(function (n) { return String(n || '').toLowerCase() === 'size'; });
      return idx === -1 ? 0 : idx;
    };

    pdp.resolveVariantId = function (handle, selectedOptions) {
      var json = productCache[handle];
      if (!json || !Array.isArray(json.variants)) return null;
      return (json.variants.find(function (v) {
        if (!v || !Array.isArray(v.options)) return false;
        for (var i = 0; i < selectedOptions.length; i++) {
          if ((v.options[i] || '') !== (selectedOptions[i] || '')) return false;
        }
        return true;
      }) || {}).id || null;
    };

    pdp.patchHiddenInput = function (variantId) {
      var sec = pdp.mainSection();
      if (!sec || !variantId) return;
      sec.querySelectorAll('form.shopify-product-form input[name="id"]').forEach(function (input) {
        if (String(input.value) !== String(variantId)) input.value = variantId;
      });
    };

    pdp.hiddenVariantId = function () {
      var sec = pdp.mainSection();
      if (!sec) return null;
      var input = sec.querySelector('form.shopify-product-form input[name="id"]');
      return input && input.value ? input.value : null;
    };

    pdp.pushVariantToUrl = function (variantId) {
      if (!variantId) return;
      var u = new URL(window.location.href);
      u.searchParams.set('variant', variantId);
      history.replaceState(Object.assign({}, history.state || {}, { variantId: variantId, ajaxProduct: true }), '', u.pathname + u.search);
    };

    pdp.syncVariantId = function () {
      var handle = pdp.currentHandle();
      var opts = pdp.selectedOptions();
      if (!handle || !opts.length) return null;
      var vid = pdp.resolveVariantId(handle, opts);
      if (vid) {
        pdp.patchHiddenInput(vid);
        pdp.pushVariantToUrl(vid);
      }
      return vid;
    };

    pdp.syncVariantIdAsync = async function () {
      var handle = pdp.currentHandle();
      var opts = pdp.selectedOptions();
      if (!handle || !opts.length) return null;
      await fetchProduct(handle);
      var vid = pdp.resolveVariantId(handle, opts);
      if (vid) {
        pdp.patchHiddenInput(vid);
        pdp.pushVariantToUrl(vid);
      }
      return vid;
    };

    pdp.onVariantReady = function (cb) {
      var vid = pdp.syncVariantId();
      if (vid) { cb(vid); return; }
      pdp.syncVariantIdAsync().then(function (vid2) { cb(vid2); });
    };

    pdp.applyVariantOptions = function (options) {
      var sec = pdp.mainSection();
      if (!sec) return;
      for (var i = 0; i < options.length; i++) {
        var val = options[i];
        var input = sec.querySelector('input[type="radio"][name="option' + (i + 1) + '"][value="' + CSS.escape(val) + '"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      setTimeout(function () { pdp.syncVariantId() || pdp.syncVariantIdAsync(); }, 0);
    };

    pdp.syncAtcButton = function (variant) {
      var sec = pdp.mainSection();
      if (!sec || !variant) return;
      var btn = sec.querySelector('form.shopify-product-form button[type="submit"]');
      if (!btn) return;
      if (variant.available) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-text-atc') || 'Add to Cart';
      } else {
        btn.disabled = true;
        if (!btn.hasAttribute('data-text-atc')) btn.setAttribute('data-text-atc', btn.textContent.trim());
        btn.textContent = 'Sold out';
      }
    };

    pdp.clearWairPopups = function () {
      document.querySelectorAll('.wair-modal, .wair-widget-modal, [data-wair-modal], .wair-overlay, iframe[src*="wair"]').forEach(function (node) {
        if (node.closest('[data-wair-preserve]')) return;
        node.remove();
      });
    };

    pdp.updateWairButton = function () {
      var wrap = document.querySelector('[data-wair-preserve]');
      if (!wrap) return;
      var btn = wrap.querySelector('button, a, [role="button"]');
      if (!btn) return;
      var vid = pdp.hiddenVariantId();
      if (vid) {
        wrap.setAttribute('data-variant-id', vid);
        btn.setAttribute('data-variant-id', vid);
      }
      var tick = String(Date.now());
      wrap.setAttribute('data-wair-tick', tick);
      btn.setAttribute('data-wair-tick', tick);
    };

    pdp.triggerWairRefresh = function () {
      try {
        if (window.WAIR && typeof window.WAIR.refresh === 'function') window.WAIR.refresh();
        else document.dispatchEvent(new Event('wair:refresh'));
      } catch (e) {}
    };

    pdp.resetAccordionState = function (root) {
      root.querySelectorAll('details[is="accordion-disclosure"]').forEach(function (d) {
        d.classList.remove('auto-open');
        d.style.height = null;
        d.style.overflow = null;
        d.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
        var c = d.querySelector(':scope > .accordion__content');
        if (c) { c.style.opacity = null; c.style.transform = null; }
      });
    };

    pdp.videoCellSource = function (cell) {
      var source = cell.querySelector('video source');
      if (source && source.src) return source.src;
      var video = cell.querySelector('video');
      return (video && video.src) || '';
    };

    pdp.preserveMatchingVideos = function (current, incoming) {
      var oldCells = current.querySelectorAll('.product-gallery__media[data-media-type="video"]');
      var newCells = incoming.querySelectorAll('.product-gallery__media[data-media-type="video"]');
      newCells.forEach(function (newCell) {
        var newMediaId = newCell.getAttribute('data-media-id');
        var oldCell = null;
        oldCells.forEach(function (c) {
          if (c.getAttribute('data-media-id') === newMediaId) oldCell = c;
        });
        if (!oldCell) return;
        var oldSrc = pdp.videoCellSource(oldCell);
        var newSrc = pdp.videoCellSource(newCell);
        if (oldSrc && newSrc && oldSrc === newSrc) {
          newCell.replaceWith(oldCell);
        }
      });
    };

    // Before a swapped-in section hits the page, carry the shopper's size over and,
    // if that size is sold out in the new color, render the sold-out state up front
    // so the button doesn't paint as Add to Cart and then fade to Sold out.
    pdp.presetCarriedSize = function (incoming) {
      var pref = window.__preferredSizeOnce || pdp.selectedSize();
      if (!pref) return;
      var radio = incoming.querySelector('input[type="radio"][name^="option"][value="' + CSS.escape(pref) + '"]');
      if (!radio) return;
      var variants = null;
      var vEl = incoming.querySelector('script[data-bis-variants]');
      try { variants = vEl ? JSON.parse(vEl.textContent) : null; } catch (e) {}
      if (!Array.isArray(variants)) return;
      var opts = [], i = 1, input;
      while ((input = incoming.querySelector('input[type="radio"][name="option' + i + '"]:checked'))) { opts.push(input.value); i++; }
      var idx = parseInt(radio.name.replace('option', ''), 10) - 1;
      if (isNaN(idx) || idx < 0) return;
      opts[idx] = pref;
      var v = variants.find(function (x) {
        return x && Array.isArray(x.options) && opts.every(function (o, k) { return (x.options[k] || '') === (o || ''); });
      });
      if (!v || v.available) return;
      radio.checked = true;
      var btn = incoming.querySelector('form.shopify-product-form button[type="submit"]');
      if (btn) {
        if (!btn.hasAttribute('data-text-atc')) btn.setAttribute('data-text-atc', btn.textContent.trim());
        btn.disabled = true;
        btn.textContent = 'Sold out';
      }
      var trigger = incoming.querySelector('[data-bis-trigger]');
      if (trigger) trigger.hidden = false;
    };

    // The color swatch row is the same on every colorway; only the selected swatch
    // and the color name differ. Reuse the already-painted thumbnail <img> nodes so
    // the row doesn't blank out and repaint on every swap.
    pdp.keepSwatchImages = function (current, incoming) {
      var cur = current.querySelector('.product-color-groups');
      var inc = incoming.querySelector('.product-color-groups');
      if (!cur || !inc) return;
      var bySrc = Object.create(null);
      cur.querySelectorAll('img').forEach(function (img) {
        var k = img.getAttribute('src');
        if (k) (bySrc[k] = bySrc[k] || []).push(img);
      });
      inc.querySelectorAll('img').forEach(function (img) {
        var list = bySrc[img.getAttribute('src')];
        if (list && list.length) img.replaceWith(list.shift());
      });
    };

    pdp.swapSectionHtml = function (sectionId, html, skipPreserve) {
      var current = document.querySelector('#shopify-section-' + sectionId);
      if (!current) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var incoming = tmp.querySelector('#shopify-section-' + sectionId);
      if (!incoming) return;

      if (skipPreserve) {
        var curAccordions = current.querySelectorAll('.accordion-group[data-preserve] details[is="accordion-disclosure"]');
        var newAccordions = incoming.querySelectorAll('.accordion-group[data-preserve] details[is="accordion-disclosure"]');
        for (var i = 0; i < Math.min(curAccordions.length, newAccordions.length); i++) {
          var curContent = curAccordions[i].querySelector('.accordion__content');
          var newContent = newAccordions[i].querySelector('.accordion__content');
          if (curContent && newContent) {
            curContent.innerHTML = newContent.innerHTML;
          }
        }

        if (current.classList.contains(PRODUCT_SECTION_CLASS)) {
          ['.accordion-group[data-preserve]', '[data-wair-preserve]'].forEach(function (sel) {
            var oldList = current.querySelectorAll(sel);
            var newList = incoming.querySelectorAll(sel);
            for (var j = 0; j < newList.length; j++) {
              var keep = oldList[j], target = newList[j];
              if (keep && target) target.replaceWith(keep);
            }
          });
          pdp.preserveMatchingVideos(current, incoming);
          pdp.presetCarriedSize(incoming);
          pdp.keepSwatchImages(current, incoming);
        }
        current.replaceWith(incoming);
      } else {
        if (current.classList.contains(PRODUCT_SECTION_CLASS)) {
          ['.accordion-group[data-preserve]', '[data-wair-preserve]'].forEach(function (sel) {
            var oldList = current.querySelectorAll(sel);
            var newList = incoming.querySelectorAll(sel);
            for (var i = 0; i < newList.length; i++) {
              var keep = oldList[i], target = newList[i];
              if (keep && target) {
                pdp.resetAccordionState(keep);
                target.replaceWith(keep);
              }
            }
          });
          pdp.preserveMatchingVideos(current, incoming);
          pdp.presetCarriedSize(incoming);
          pdp.keepSwatchImages(current, incoming);
        }
        current.replaceWith(incoming);
      }
    };

    pdp.swapSectionImages = function (sectionId, html) {
      var currentRoot = document.querySelector('#shopify-section-' + sectionId);
      if (!currentRoot) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var incomingRoot = tmp.querySelector('#shopify-section-' + sectionId);
      if (!incomingRoot) return;

      var selector = 'img.Callout__Image, img.feature-callouts__image';
      var inImgs = incomingRoot.querySelectorAll(selector);
      var curImgs = currentRoot.querySelectorAll(selector);
      var count = Math.min(inImgs.length, curImgs.length);
      for (var i = 0; i < count; i++) {
        var src = inImgs[i], dst = curImgs[i];
        ['src', 'srcset', 'sizes', 'alt', 'data-src', 'data-srcset', 'data-sizes', 'data-widths', 'data-optimumx'].forEach(function (name) {
          var val = src.getAttribute(name);
          if (val !== null) dst.setAttribute(name, val);
          else dst.removeAttribute(name);
        });
        if (dst.classList.contains('Image--lazyLoad')) {
          dst.classList.add('lazyload', 'lazyautosizes');
          dst.classList.remove('is-loaded', 'Image--lazyLoaded');
          if (window.lazySizes && lazySizes.loader) lazySizes.loader.unveil(dst);
        }
      }

      var textSelector = '.feature-callouts__title, .feature-callouts__description, .Product__CalloutText, .Product_CalloutDescription';
      var inTexts = incomingRoot.querySelectorAll(textSelector);
      var curTexts = currentRoot.querySelectorAll(textSelector);
      var textCount = Math.min(inTexts.length, curTexts.length);
      for (var t = 0; t < textCount; t++) {
        if (curTexts[t].innerHTML !== inTexts[t].innerHTML) {
          curTexts[t].innerHTML = inTexts[t].innerHTML;
        }
      }
    };

    pdp.activateLazyImages = function (root) {
      if (!root) return;
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.getAttribute('src') && img.dataset && img.dataset.src && img.dataset.src.indexOf('{width}') === -1) {
          img.setAttribute('src', img.dataset.src);
        }
        if (!img.getAttribute('srcset') && img.dataset && img.dataset.srcset && img.dataset.srcset.indexOf('{width}') === -1) {
          img.setAttribute('srcset', img.dataset.srcset);
        }
        if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
        img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
      });
    };

    pdp.reinitialize = function () {
      var sec = pdp.mainSection();
      if (!sec) return;
      var id = sec.id.replace('shopify-section-', '');

      try {
        document.dispatchEvent(new CustomEvent('shopify:section:unload', { detail: { sectionId: id } }));
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: id } }));
      } catch (e) {}

      try {
        if (window.Prestige && typeof window.Prestige.init === 'function') window.Prestige.init();
        if (window.theme && typeof window.theme.initProduct === 'function') window.theme.initProduct(sec);
      } catch (e) {}

      var pref = (typeof window.__preferredSizeOnce !== 'undefined' && window.__preferredSizeOnce) ? window.__preferredSizeOnce : pdp.selectedSize();
      window.__preferredSizeOnce = null;
      if (pref) {
        var json = pdp.currentProductJson();
        if (json) {
          var current = pdp.selectedOptions();
          if (current.length) {
            var sizeIdx = pdp.sizeOptionIndex(json);
            var tryOptions = current.slice();
            tryOptions[sizeIdx] = pref;
            pdp.applyVariantOptions(tryOptions);
          }
        }
      } else {
        pdp.syncVariantId() || pdp.syncVariantIdAsync();
      }

      pdp.onVariantReady(function (vid) {
        // Carried-over size after a color swap is set without a user click, so the
        // theme never relabels the button; sync it from the resolved variant.
        var pj = pdp.currentProductJson();
        var v = pj && Array.isArray(pj.variants) && pj.variants.find(function (x) { return String(x.id) === String(vid); });
        if (v && !v.available) pdp.syncAtcButton(v);
        pdp.clearWairPopups();
        pdp.updateWairButton();
        pdp.triggerWairRefresh();
      });

      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      if (window.lazySizes && lazySizes.autoSizer && lazySizes.autoSizer.checkElems) lazySizes.autoSizer.checkElems();

      var g = sec.querySelector(GALLERY_SELECTOR);
      var lead = g && g.querySelector('.product-gallery__media.is-initial img, .product-gallery__media.is-active img');
      if (lead && lead.complete && lead.naturalWidth > 0) lead.classList.add('is-loaded');

    };

    pdp.buildRefreshPlan = function () {
      var plan = [];
      var mainId = pdp.mainSectionId();
      if (mainId) plan.push({ id: mainId, mode: 'full' });
      document.querySelectorAll('[data-product-refresh-full]').forEach(function (el) {
        var id = pdp.wrappingSectionId(el);
        if (id && !plan.some(function (p) { return p.id === id; })) plan.push({ id: id, mode: 'full' });
      });
      document.querySelectorAll('[data-product-refresh-images]').forEach(function (el) {
        var id = pdp.wrappingSectionId(el);
        if (id && !plan.some(function (p) { return p.id === id; })) plan.push({ id: id, mode: 'images' });
      });
      return plan;
    };

    pdp.applySwap = function (plan, ids, url, json, skipPreserve) {
      plan.forEach(function (p) {
        var html = json[p.id];
        if (!html) return;
        if (p.mode === 'images') pdp.swapSectionImages(p.id, html);
        else pdp.swapSectionHtml(p.id, html, !!skipPreserve);
      });
      history.replaceState({ ajaxProduct: true, sectionIds: ids }, '', url.pathname + url.search);
      pdp.activateLazyImages(document);
      pdp.reinitialize();
    };

    pdp.prefetchColor = function (url) {
      var plan = pdp.buildRefreshPlan();
      if (!plan.length) return;
      var ids = plan.map(function (p) { return p.id; });
      var sectionsUrl = pdp.buildSectionsUrl(url, ids);
      if (sectionCache[sectionsUrl] || sectionInFlight[sectionsUrl]) return;
      var handle = (url.pathname.match(/\/products\/([^\/\?]+)/) || [])[1];
      if (handle) fetchProduct(handle);
      sectionInFlight[sectionsUrl] = fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          sectionCache[sectionsUrl] = json;
          delete sectionInFlight[sectionsUrl];
          var mainId = pdp.mainSectionId();
          var html = json[mainId];
          if (!html) return json;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          tmp.querySelectorAll('.product-gallery__media img').forEach(function (img) {
            var src = img.getAttribute('src') || '';
            if (!src) {
              var ds = img.getAttribute('data-src') || '';
              if (ds && ds.indexOf('{width}') === -1) src = ds;
            }
            if (src) preloadImage(src, img.getAttribute('srcset') || '', img.getAttribute('sizes') || '');
          });
          return json;
        })
        .catch(function () { delete sectionInFlight[sectionsUrl]; });
    };

    pdp.navigateTo = function (url, skipPreserve) {
      window.__preferredSizeOnce = pdp.selectedSize();

      var handle = (url.pathname.match(/\/products\/([^\/\?]+)/) || [])[1];
      if (handle) fetchProduct(handle);

      var plan = pdp.buildRefreshPlan();
      if (!plan.length) { window.location.href = url; return; }

      var ids = plan.map(function (p) { return p.id; });
      var sectionsUrl = pdp.buildSectionsUrl(url, ids);

      var cached = sectionCache[sectionsUrl];
      if (cached) {
        pdp.applySwap(plan, ids, url, cached, skipPreserve);
        return;
      }

      var pending = sectionInFlight[sectionsUrl];
      var fetchPromise = pending || fetch(sectionsUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); });

      pdp.toggleLoading(true);
      fetchPromise
        .then(function (json) {
          if (!json) throw new Error('no data');
          pdp.applySwap(plan, ids, url, json, skipPreserve);
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { pdp.toggleLoading(false); });
    };

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      if (!a.closest('.variant-picker__option-values')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;

      var href = a.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;
      if (!a.closest('.' + PRODUCT_SECTION_CLASS)) return;

      e.preventDefault();
      var isOptionLink = !!a.closest('.product-option-links');
      pdp.navigateTo(new URL(href, window.location.origin), isOptionLink);
    });

    function onSwatchIntent(e) {
      var a = e.target.closest('a');
      if (!a) return;
      if (!a.closest('.variant-picker__option-values')) return;
      var href = a.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;
      if (!a.closest('.' + PRODUCT_SECTION_CLASS)) return;
      pdp.prefetchColor(new URL(href, window.location.origin));
    }
    document.addEventListener('mouseover', onSwatchIntent, { passive: true });
    document.addEventListener('touchstart', onSwatchIntent, { passive: true });

    window.addEventListener('popstate', function (e) {
      if (!e.state || !e.state.ajaxProduct) return;

      window.__preferredSizeOnce = pdp.selectedSize();

      var plan = pdp.buildRefreshPlan();
      if (!plan.length) return;
      var ids = plan.map(function (p) { return p.id; });
      var sectionsUrl = pdp.buildSectionsUrl(window.location.href, ids);

      pdp.toggleLoading(true);
      fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          plan.forEach(function (p) {
            var html = json[p.id];
            if (!html) return;
            if (p.mode === 'images') pdp.swapSectionImages(p.id, html);
            else pdp.swapSectionHtml(p.id, html);
          });
          pdp.activateLazyImages(document);
          pdp.reinitialize();
        })
        .finally(function () { pdp.toggleLoading(false); });
    });

    document.addEventListener('DOMContentLoaded', function () {
      var h = pdp.currentHandle();
      if (h) fetchProduct(h);
      pdp.activateLazyImages(document);
      pdp.reinitialize();
    });
  }

  (function initCollectionCards() {
    var PREFETCH = {
      enable: true,
      maxPerCard: 8,
      prefetchSecondary: true,
      viewportLookahead: 1.2,
      maxConcurrent: 4
    };

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-card-swatches]').forEach(function (root) {
        var more = root.querySelector('[data-swatch-more]');
        var selected = root.querySelector('a.color-swatch.is-selected, a.thumbnail-swatch.is-selected');
        if (more && selected) more.href = selected.href;
      });
    });

    var inflight = 0;
    var taskQueue = [];

    function enqueue(task) {
      taskQueue.push(task);
      flushQueue();
    }

    function flushQueue() {
      if (inflight >= PREFETCH.maxConcurrent || !taskQueue.length) return;
      inflight++;
      var fn = taskQueue.shift();
      var done = function () { inflight--; flushQueue(); };
      try {
        var p = fn();
        if (p && p.then) p.finally(done);
        else done();
      } catch (e) { done(); }
    }

    function isInsidePdp(el) { return !!el.closest('.shopify-section--main-product'); }
    function closestCard(el) { return el.closest('product-card.product-card'); }
    function primaryImage(c) { return c ? c.querySelector('img.product-card__image--primary') : null; }
    function secondaryImage(c) { return c ? c.querySelector('img.product-card__image--secondary') : null; }
    function cardMediaLink(c) { return c ? c.querySelector('a.product-card__media') : null; }
    function cardTitleLink(c) { return c ? c.querySelector('a.product-title') : null; }
    function cardColorLink(c) { return c ? c.querySelector('a.product-color') : null; }
    function cardPriceList(c) { return c ? c.querySelector('price-list.price-list') : null; }
    function cardBadgeList(c) { return c ? c.querySelector('badge-list.badge-list') : null; }
    function cardDsgEl(c) { return c ? c.querySelector('[data-dsg]') : null; }

    function extractSwatchLabel(a) {
      var s = (a.getAttribute('aria-label') || '').trim();
      if (s) return s;
      var sr = a.querySelector('.sr-only');
      return sr ? sr.textContent.trim() : '';
    }

    function splitProductTitle(fullTitle) {
      var t = String(fullTitle || '').trim();
      var dsg = '';
      if (t.indexOf('. ') > -1) {
        var dotParts = t.split('. ');
        dsg = dotParts[0];
        t = dotParts.slice(1).join('. ');
      }
      var parts = t.split(' - ');
      return {
        dsg: dsg,
        name: (parts[0] || '').trim(),
        color: (parts.slice(1).join(' - ') || '').trim()
      };
    }

    function resolveCurrencyFormat() {
      var tv = window.themeVariables && window.themeVariables.settings;
      if (tv && tv.currencyCodeEnabled && tv.moneyWithCurrencyFormat) return tv.moneyWithCurrencyFormat;
      if (tv && tv.moneyFormat) return tv.moneyFormat;
      return (window.Shopify && Shopify.money_format) || '${{amount}}';
    }

    function formatCents(cents, format) {
      format = format || resolveCurrencyFormat();
      if (cents === null || typeof cents === 'undefined') return '';
      if (typeof cents === 'string') cents = cents.replace('.', '');
      cents = parseInt(cents, 10);
      if (isNaN(cents)) return '';

      function delimit(number, precision, thousands, decimal) {
        precision = (typeof precision === 'number') ? precision : 2;
        thousands = thousands || ',';
        decimal = decimal || '.';
        var num = (number / 100).toFixed(precision);
        var parts = num.split('.');
        var dollars = parts[0];
        var centsPart = parts[1] || '';
        dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return precision ? (dollars + decimal + centsPart) : dollars;
      }

      var placeholderMatch = format.match(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_space_separator|amount_no_decimals_with_space_separator|amount_with_apostrophe_separator)\s*\}\}/);
      var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

      var value = '';
      switch (placeholder) {
        case 'amount':
          value = delimit(cents, 2, ',', '.');
          break;
        case 'amount_no_decimals':
          value = delimit(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = delimit(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = delimit(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = delimit(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = delimit(cents, 0, ' ', '.');
          break;
        case 'amount_with_apostrophe_separator':
          value = delimit(cents, 2, "'", '.');
          break;
        default:
          value = delimit(cents, 2, ',', '.');
      }

      return placeholderMatch ? format.replace(placeholderMatch[0], value) : value;
    }

    function formatCentsClean(cents) {
      var out = formatCents(cents, resolveCurrencyFormat());
      return String(out).replace(/(\d)[\.,]00(?!\d)/g, '$1');
    }

    function lowestPriceVariant(productJson) {
      var vs = (productJson && productJson.variants) ? productJson.variants.slice() : [];
      if (!vs.length) return null;
      vs.sort(function (a, b) { return (Number(a.price) || 0) - (Number(b.price) || 0); });
      return vs[0];
    }

    function applyCardDsg(cardEl, productJson) {
      var el = cardDsgEl(cardEl);
      if (!el) return;
      var product = splitProductTitle(productJson && productJson.title);
      if (product.dsg) {
        el.textContent = 'DSG-' + product.dsg;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    }

    function applyCardTitleAndLinks(cardEl, href, productJson) {
      var tA = cardTitleLink(cardEl);
      var cA = cardColorLink(cardEl);
      var product = splitProductTitle(productJson && productJson.title);
      var mode = cardEl.getAttribute('data-dsg-mode') || 'badge';

      if (tA) {
        var titleText = product.name || '';
        if (mode === 'inline' && product.dsg) titleText = product.dsg + '. ' + titleText;
        if (titleText) tA.textContent = titleText;
        tA.href = href;
      }

      if (cA) {
        if (product.color) cA.textContent = product.color;
        cA.href = href;
      } else if (tA) {
        if (product.name && product.color) {
          var full = product.name + ' - ' + product.color;
          if (mode === 'inline' && product.dsg) full = product.dsg + '. ' + full;
          tA.textContent = full;
        }
      }

      var mA = cardMediaLink(cardEl);
      if (mA) mA.href = href;
    }

    function applyCardImages(cardEl, productJson) {
      var imgs = (productJson && productJson.images) ? productJson.images : [];
      var primary = imgs[0] || '';
      var secondary = imgs[1] || primary;

      var lead = primaryImage(cardEl);
      var hover = secondaryImage(cardEl);

      if (lead && primary) {
        lead.removeAttribute('srcset');
        lead.src = primary;
        if (productJson && productJson.title) lead.alt = productJson.title;
      }

      if (hover && secondary) {
        hover.removeAttribute('srcset');
        hover.src = secondary;
        if (productJson && productJson.title) hover.alt = productJson.title;
      }

      return { primary: primary, secondary: secondary };
    }

    function getOrCreateSalePrice(priceList) {
      var saleEl = priceList.querySelector('sale-price');
      if (saleEl) return saleEl;
      saleEl = document.createElement('sale-price');
      saleEl.className = 'Pricing h6';
      saleEl.innerHTML = '<span class="sr-only">Sale price</span>';
      priceList.appendChild(saleEl);
      return saleEl;
    }

    function applyCardPrice(cardEl, productJson) {
      var priceList = cardPriceList(cardEl);
      if (!priceList) return;

      var v = lowestPriceVariant(productJson);
      if (!v) return;

      var price = Number(v.price) || 0;
      var compare = Number(v.compare_at_price) || 0;
      var onSale = compare > price;

      var saleEl = getOrCreateSalePrice(priceList);
      saleEl.classList.toggle('text-on-sale', onSale);
      saleEl.classList.toggle('text-subdued', !onSale);

      var sr = saleEl.querySelector('.sr-only');
      saleEl.innerHTML = '';
      if (sr) saleEl.appendChild(sr);
      else {
        var s = document.createElement('span');
        s.className = 'sr-only';
        s.textContent = 'Sale price';
        saleEl.appendChild(s);
      }
      saleEl.insertAdjacentHTML('beforeend', formatCentsClean(price));

      var compareEl = priceList.querySelector('compare-at-price');
      if (onSale) {
        if (!compareEl) {
          compareEl = document.createElement('compare-at-price');
          compareEl.className = 'Pricing h6 text-subdued line-through';
          priceList.appendChild(compareEl);
        }
        compareEl.innerHTML = '<span class="sr-only">Regular price</span>' + formatCentsClean(compare);
      } else {
        if (compareEl) compareEl.remove();
      }
    }

    function applyCardBadges(cardEl, productJson) {
      var badgeList = cardBadgeList(cardEl);
      if (!badgeList) return;

      var tags = (productJson && productJson.tags) ? productJson.tags : [];
      var available = !!(productJson && productJson.available);

      Array.from(badgeList.children).forEach(function (node) {
        if (node.tagName && node.tagName.toLowerCase() === 'style') return;
        node.remove();
      });

      var hasBestSeller = tags.indexOf('bestseller-badge') > -1;
      var hasNew = tags.indexOf('new-badge') > -1;
      var hasLimited = tags.indexOf('limited25') > -1;

      if (!available) {
        var soldEl = document.createElement('sold-out-badge');
        soldEl.className = 'badge badge--sold-out';
        soldEl.textContent = (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.soldOutBadge) || 'Sold out';
        badgeList.appendChild(soldEl);
        return;
      }

      if (hasBestSeller) {
        var bestEl = document.createElement('bestseller');
        bestEl.className = 'badge badge--bestseller';
        bestEl.textContent = 'Best Seller';
        badgeList.appendChild(bestEl);
        return;
      }

      if (hasNew) {
        var newEl = document.createElement('new-badge');
        newEl.className = 'badge badge--new';
        newEl.textContent = 'New';
        badgeList.appendChild(newEl);
        return;
      }

      if (hasLimited) {
        var limitedEl = document.createElement('limited-badge');
        limitedEl.className = 'badge badge--limited';
        limitedEl.textContent = 'Limited Edition';
        badgeList.appendChild(limitedEl);
      }
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
      if (!a) return;
      if (isInsidePdp(a)) return;

      var c = closestCard(a);
      if (!c) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var href = a.getAttribute('href');
      var group = a.closest('.variant-picker__color-swatches');
      var more = group && group.querySelector('[data-swatch-more]');
      if (more) more.setAttribute('href', href);

      var handle = handleFromHref(href);
      if (!handle) return;

      var wrap = a.closest('.variant-picker__color-swatches');
      if (wrap) {
        wrap.querySelectorAll('a.color-swatch, a.thumbnail-swatch').forEach(function (n) { n.classList.remove('is-selected'); });
        a.classList.add('is-selected');
      }

      var cA = cardColorLink(c);
      var label = extractSwatchLabel(a);
      if (cA) {
        if (label) cA.textContent = label;
        cA.href = href;
      }

      if (c.__swatchCtrl) try { c.__swatchCtrl.abort(); } catch (_) {}
      var ctrl = new AbortController();
      c.__swatchCtrl = ctrl;
      c.__swatchToken = (c.__swatchToken || 0) + 1;
      var token = c.__swatchToken;

      fetchProduct(handle, ctrl.signal)
        .then(function (j) {
          if (!j || token !== c.__swatchToken) return;

          c.dataset.activeHandle = handle;
          c.setAttribute('handle', handle);

          applyCardTitleAndLinks(c, href, j);
          if (cA && label) cA.textContent = label;
          applyCardDsg(c, j);
          applyCardBadges(c, j);
          applyCardPrice(c, j);

          var imgs = applyCardImages(c, j);
          return Promise.allSettled([
            preloadImage(imgs.primary),
            PREFETCH.prefetchSecondary ? preloadImage(imgs.secondary) : Promise.resolve()
          ]);
        })
        .catch(function () {});
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
      if (!a || isInsidePdp(a)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      a.click();
    }, true);

    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
      if (!a || isInsidePdp(a)) return;
      var handle = handleFromHref(a.getAttribute('href'));
      if (!handle) return;

      enqueue(function () {
        return fetchProduct(handle).then(function (j) {
          if (!j) return;
          var imgs = j.images || [];
          var p = imgs[0] || '';
          var s = imgs[1] || p;
          var tasks = [];
          if (p) tasks.push(preloadImage(p));
          if (PREFETCH.prefetchSecondary && s) tasks.push(preloadImage(s));
          return Promise.allSettled(tasks);
        });
      });
    }, { passive: true });

    if ('IntersectionObserver' in window && PREFETCH.enable) {
      var prefetchObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.intersectionRatio === 0) return;
          var c = entry.target;
          var wrap = c.querySelector('[data-card-swatches]') || c;
          var links = wrap.querySelectorAll('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
          var limit = Math.min(links.length, PREFETCH.maxPerCard);

          for (var i = 0; i < limit; i++) {
            (function (a) {
              var h = handleFromHref(a.getAttribute('href'));
              if (!h) return;
              enqueue(function () {
                return fetchProduct(h).then(function (j) {
                  if (!j) return;
                  var imgs = j.images || [];
                  var p = imgs[0] || '';
                  var s = imgs[1] || p;
                  return PREFETCH.prefetchSecondary
                    ? Promise.allSettled([preloadImage(p), preloadImage(s)])
                    : preloadImage(p);
                });
              });
            })(links[i]);
          }

          prefetchObserver.unobserve(c);
        });
      }, { root: null, rootMargin: Math.round((PREFETCH.viewportLookahead - 1) * 100) + '% 0px', threshold: [0, 0.01] });

      document.querySelectorAll('product-card.product-card').forEach(function (pc) { prefetchObserver.observe(pc); });
    }

    (function initDynamicSwatchCount() {
      var MOBILE_BREAKPOINT = 650;

      function checkMobile() { return window.innerWidth < MOBILE_BREAKPOINT; }

      function clampSwatchVisibility(container) {
        if (!container) return;

        var swatches = Array.from(container.querySelectorAll('a.color-swatch, a.thumbnail-swatch'));
        var moreBtn = container.querySelector('[data-swatch-more]');
        if (!swatches.length) return;

        var total = parseInt(container.getAttribute('data-total-colors')) || swatches.length;
        var maxMobile = parseInt(container.getAttribute('data-max-mobile')) || 5;
        var maxDesktop = parseInt(container.getAttribute('data-max-desktop')) || 9;
        var mobile = checkMobile();
        var maxVisible = mobile ? maxMobile : maxDesktop;

        swatches.forEach(function (s) { s.style.display = ''; });
        if (moreBtn) moreBtn.style.display = '';
        container.offsetHeight;

        var visible = 0;

        if (mobile) {
          for (var i = 0; i < swatches.length; i++) {
            if (i < maxVisible) visible++;
            else swatches[i].style.display = 'none';
          }
        } else {
          var firstRowTop = swatches[0].offsetTop;
          for (var k = 0; k < swatches.length; k++) {
            if (swatches[k].offsetTop === firstRowTop && k < maxVisible) visible++;
            else {
              for (var j = k; j < swatches.length; j++) swatches[j].style.display = 'none';
              break;
            }
          }
        }

        if (moreBtn) {
          var remaining = total - visible;
          if (remaining > 0) {
            moreBtn.style.display = '';
            var countSpan = moreBtn.querySelector('[data-remaining-count]');
            if (countSpan) countSpan.textContent = remaining;
          } else {
            moreBtn.style.display = 'none';
          }
        }
      }

      function clampAllSwatches() {
        document.querySelectorAll('.variant-picker__color-swatches').forEach(clampSwatchVisibility);
      }

      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(clampAllSwatches, 300);
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(clampAllSwatches, 100);
      });
    })();

    function cardIsSoldOut(c) {
      return !!c.querySelector('sold-out-badge, .badge--sold-out');
    }

    function cardSwatchLinks(c) {
      return Array.from(
        c.querySelectorAll('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch')
      ).filter(function (a) {
        if (!a || !a.getAttribute('href')) return false;
        if (a.hasAttribute('data-swatch-more')) return false;
        return true;
      });
    }

    function nextAvailableSwatch(swatches, startIndex) {
      if (!swatches || !swatches.length) return null;
      for (var step = 1; step <= swatches.length; step++) {
        var idx = (startIndex + step) % swatches.length;
        var cand = swatches[idx];
        if (!cand.classList.contains('sold_out')) return cand;
      }
      return null;
    }

    function swapSoldOutCard(c) {
      if (!c || c.__autoSwappedOnce) return;
      if (!cardIsSoldOut(c)) return;

      var swatches = cardSwatchLinks(c);
      if (swatches.length < 2) return;

      var selected = swatches.find(function (a) { return a.classList.contains('is-selected'); }) || swatches[0];
      var startIndex = Math.max(0, swatches.indexOf(selected));

      var next = nextAvailableSwatch(swatches, startIndex);
      if (!next || next === selected) return;

      c.__autoSwappedOnce = true;
      next.click();
    }

    (function initAutoSwapSoldOut() {
      function watchCard(pc) {
        if (!pc || pc.__autoSwapObserved) return;
        pc.__autoSwapObserved = true;
        soldOutObserver.observe(pc);
      }

      var soldOutObserver = ('IntersectionObserver' in window)
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var pc = entry.target;
              soldOutObserver.unobserve(pc);
              swapSoldOutCard(pc);
            });
          }, { root: null, rootMargin: '60% 0px', threshold: 0.01 })
        : null;

      if (!soldOutObserver) {
        document.querySelectorAll('product-card.product-card').forEach(function (pc) { swapSoldOutCard(pc); });
        return;
      }

      document.querySelectorAll('product-card.product-card').forEach(watchCard);

      var domObserver = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          Array.from(m.addedNodes || []).forEach(function (n) {
            if (!n || n.nodeType !== 1) return;
            if (n.matches && n.matches('product-card.product-card')) watchCard(n);
            if (n.querySelectorAll) n.querySelectorAll('product-card.product-card').forEach(watchCard);
          });
        });
      });
      domObserver.observe(document.body, { childList: true, subtree: true });
    })();

  })();
})();

